import styled, { css } from "styled-components";
import SectionTitle from "./SectionTitle";
import { useMemo, useState } from "react";
import Card from "./Card";
import FadeInItem from "./FadeInItem";
import { handleLink } from "../utils/handleLink";
import { BREAK_POINT } from "../constants";

const News = () => {
  const [open, setOpen] = useState(false);
  const newsList = useMemo(
    () => [
      {
        link: "https://www.instagram.com/p/C88B6vxiqIy/",
        id: "insta_news_11.jpg",
        title: "처음 본 순간 - 윈터",
        sub: "음원 발매 시작!",
      },
      {
        link: "https://www.instagram.com/p/C85dHCpKmRf/",
        id: "insta_news_10.jpg",
        title: "메인 포스터 공개",
        sub: "8월 7일 극장에서 만나요!",
      },
      {
        link: "https://www.instagram.com/p/C83T0ecppse/?img_index=1",
        id: "insta_news_9.jpg",
        title: "하츄핑크 모집",
        sub: "<사랑의 하츄핑> 서포터즈",
      },
      {
        link: "https://www.instagram.com/p/C8vzJEFJ2VG/",
        id: "insta_news_8.jpg",
        title: "네이버 오픈톡 오픈",
        sub: "자유롭게 대화해보자!",
      },
      {
        link: "https://www.instagram.com/p/C8vQzatBNcs/",
        id: "insta_news_7.jpg",
        title: "'처음 본 순간' OST 주인공",
        sub: "윈터 of aespa",
      },
      {
        link: "https://www.instagram.com/p/C8tiefFvV5Z/",
        id: "insta_news_6.jpg",
        title: "하츄핑하우스에 놀러올래?",
        sub: "티니핑월드 인 판교에서 만나요!",
      },
      {
        link: "https://www.instagram.com/p/C8slIgvs5Sx/",
        id: "insta_news_5.png",
        title: "소울메이트 포스터 공개",
        sub: "8월 7일 극장 대개봉!",
      },
      {
        link: "https://www.instagram.com/p/C8Y8k7FMcfi/",
        id: "insta_news_4.jpg",
        title: "캐치! 티니핑 드림페스타",
        sub: "대전 현대 프리미엄 아울렛에서\n만나요!",
      },
      {
        link: "https://www.instagram.com/p/C8YMhrtvV2i/",
        id: "insta_news_3.png",
        title: "밤하늘 포스터 공개",
        sub: "8월 최초 극장 개봉 확정",
      },
      {
        link: "https://www.instagram.com/p/C7nd-3zhgOv/",
        id: "insta_news_2.jpg",
        title: "티니핑크닉 개최",
        sub: "동탄 레이크꼬모에서 만나요!",
      },
      {
        link: "https://www.instagram.com/p/C51wtSUMqzM/",
        id: "insta_news_1.jpg",
        title: "론칭 아트 대공개",
        sub: "올여름 극장에서 만나요!",
      },
    ],
    []
  );

  return (
    <Wrapper id="news">
      <SectionTitle>NEWS</SectionTitle>
      <FadeInItem point={0.25}>
        <NewsWrapper $open={open}>
          <div>
            {newsList.map((news) => (
              <Card
                key={news.id}
                id={news.id}
                title={news.title}
                sub={news.sub}
                handleClick={() => handleLink(news.link)}
              />
            ))}
            <Empty></Empty>
          </div>
        </NewsWrapper>
      </FadeInItem>
      <LoadMoreButton onClick={() => setOpen(!open)}>
        <img
          src={open ? "/assets/icon_more_close.png" : "/assets/icon_more.png"}
          alt="close more"
        />
      </LoadMoreButton>
    </Wrapper>
  );
};

export default News;

const Wrapper = styled.div`
  padding: 140px 0 62px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media only screen and (max-width: 1150px) {
    padding: 80px 0 4px;
  }
`;

const NewsWrapper = styled.div<{ $open?: boolean }>`
  display: flex;
  justify-content: center;
  width: 100%;

  > div {
    @media only screen and (min-width: 1150px) {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      gap: 30px;
      margin-top: 100px;
      overflow: hidden;
      will-change: max-height;
      max-height: ${({ $open }) => ($open ? "2200px" : "484px")};
      transition: max-height 1s ease;
    }

    @media only screen and (max-width: 1150px) {
      width: 100%;
      display: flex;
      gap: 16px;
      padding: 0 16px;
      overflow-x: scroll;
      margin-top: 24px;
    }
  }
`;

const LoadMoreButton = styled.div`
  cursor: pointer;
  margin-top: 50px;

  @media only screen and (max-width: 1150px) {
    display: none;
  }
`;

const Empty = styled.div`
  display: none;

  @media only screen and (min-width: 1150px) {
    display: block;
    width: 30%;
  }

  @media only screen and (min-width: ${BREAK_POINT.tablet}) {
    min-width: 360px;
    max-width: 384px;
  }

  @media only screen and (max-width: ${BREAK_POINT.tablet}) {
    min-width: 320px;
    white-space: pre;
  }
`;
